.select {
  width: 100%;
  font-weight: normal;
}

.col {
  flex-grow: 5;
  flex-basis: 0;
}

.error {
  border: 1px solid var(--red) !important;
  outline-color: var(--red) !important;
}
